import { render, staticRenderFns } from "./MealPlanner.vue?vue&type=template&id=e4a7f3c2&scoped=true&"
import script from "./MealPlanner.vue?vue&type=script&lang=js&"
export * from "./MealPlanner.vue?vue&type=script&lang=js&"
import style0 from "./MealPlanner.vue?vue&type=style&index=0&id=e4a7f3c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a7f3c2",
  null
  
)

export default component.exports